<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="tab1" @click="goCategories">
          <ion-icon :icon="duplicateOutline"></ion-icon>
          <ion-label>Nueva</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab2" @click="goTab('list')">
          <ion-icon :icon="layersOutline" />
          <ion-label>Tramitadas</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab3" @click="goTab('map')">
          <ion-icon :icon="navigateCircleOutline" />
          <ion-label>Plano</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
    <form-login-modal v-model:display="showModal" @save="saveUser" />
  </ion-page>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet } from '@ionic/vue'
import { duplicateOutline, layersOutline, navigateCircleOutline } from 'ionicons/icons'

import { useRouter }  from 'vue-router'

import { useIncidenciaStore } from '@/stores/incidencia-store'
import { useIncidenciaList } from '@/modules/incidencia-list'

import { UserCredentials } from '@/models/UserCredentials'
import FormLoginModal from '@/components/FormLoginModal'

const router = useRouter()
const store = useIncidenciaStore()

const showModal = ref<boolean>(false)
const routeName = ref<string>()
const { needLogin } = useIncidenciaList()

const goCategories = () => {
  store.reset()
  router.push({ name: 'create' })
}

const goTab = async (name: string) => {
  routeName.value = name

  if (needLogin.value) showModal.value = true
  else await router.push({ name })
}

const saveUser = (user: UserCredentials) => {
  store.setUser(user)
  router.push({ name: routeName.value })
}
</script>
